import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../hooks/useAuth";
import {
  validateEmail,
  validatePassword,
  validateName,
} from "../utils/validators";
import Button from "../components/common/Button";
import Input from "../components/common/Input";
import LoadingSpinner from "../components/common/LoadingSpinner";
import Toast from "../components/common/Toast";

const countryDirectory = [
  { name: "Afghanistan", iso: "AF", dialCode: "+93" },
  { name: "Albania", iso: "AL", dialCode: "+355" },
  { name: "Algeria", iso: "DZ", dialCode: "+213" },
  { name: "Andorra", iso: "AD", dialCode: "+376" },
  { name: "Angola", iso: "AO", dialCode: "+244" },
  { name: "Antigua and Barbuda", iso: "AG", dialCode: "+1-268" },
  { name: "Argentina", iso: "AR", dialCode: "+54" },
  { name: "Armenia", iso: "AM", dialCode: "+374" },
  { name: "Australia", iso: "AU", dialCode: "+61" },
  { name: "Austria", iso: "AT", dialCode: "+43" },
  { name: "Azerbaijan", iso: "AZ", dialCode: "+994" },
  { name: "Bahamas", iso: "BS", dialCode: "+1-242" },
  { name: "Bahrain", iso: "BH", dialCode: "+973" },
  { name: "Bangladesh", iso: "BD", dialCode: "+880" },
  { name: "Barbados", iso: "BB", dialCode: "+1-246" },
  { name: "Belarus", iso: "BY", dialCode: "+375" },
  { name: "Belgium", iso: "BE", dialCode: "+32" },
  { name: "Belize", iso: "BZ", dialCode: "+501" },
  { name: "Benin", iso: "BJ", dialCode: "+229" },
  { name: "Bhutan", iso: "BT", dialCode: "+975" },
  { name: "Bolivia", iso: "BO", dialCode: "+591" },
  { name: "Bosnia and Herzegovina", iso: "BA", dialCode: "+387" },
  { name: "Botswana", iso: "BW", dialCode: "+267" },
  { name: "Brazil", iso: "BR", dialCode: "+55" },
  { name: "Brunei", iso: "BN", dialCode: "+673" },
  { name: "Bulgaria", iso: "BG", dialCode: "+359" },
  { name: "Burkina Faso", iso: "BF", dialCode: "+226" },
  { name: "Burundi", iso: "BI", dialCode: "+257" },
  { name: "Cambodia", iso: "KH", dialCode: "+855" },
  { name: "Cameroon", iso: "CM", dialCode: "+237" },
  { name: "Canada", iso: "CA", dialCode: "+1" },
  { name: "Cabo Verde", iso: "CV", dialCode: "+238" },
  { name: "Central African Republic", iso: "CF", dialCode: "+236" },
  { name: "Chad", iso: "TD", dialCode: "+235" },
  { name: "Chile", iso: "CL", dialCode: "+56" },
  { name: "China", iso: "CN", dialCode: "+86" },
  { name: "Colombia", iso: "CO", dialCode: "+57" },
  { name: "Comoros", iso: "KM", dialCode: "+269" },
  { name: "Congo", iso: "CG", dialCode: "+242" },
  { name: "Costa Rica", iso: "CR", dialCode: "+506" },
  { name: "Croatia", iso: "HR", dialCode: "+385" },
  { name: "Cuba", iso: "CU", dialCode: "+53" },
  { name: "Cyprus", iso: "CY", dialCode: "+357" },
  { name: "Czech Republic", iso: "CZ", dialCode: "+420" },
  { name: "Democratic Republic of the Congo", iso: "CD", dialCode: "+243" },
  { name: "Denmark", iso: "DK", dialCode: "+45" },
  { name: "Djibouti", iso: "DJ", dialCode: "+253" },
  { name: "Dominica", iso: "DM", dialCode: "+1-767" },
  { name: "Dominican Republic", iso: "DO", dialCode: "+1-809" },
  { name: "Ecuador", iso: "EC", dialCode: "+593" },
  { name: "Egypt", iso: "EG", dialCode: "+20" },
  { name: "El Salvador", iso: "SV", dialCode: "+503" },
  { name: "Equatorial Guinea", iso: "GQ", dialCode: "+240" },
  { name: "Eritrea", iso: "ER", dialCode: "+291" },
  { name: "Estonia", iso: "EE", dialCode: "+372" },
  { name: "Eswatini", iso: "SZ", dialCode: "+268" },
  { name: "Ethiopia", iso: "ET", dialCode: "+251" },
  { name: "Fiji", iso: "FJ", dialCode: "+679" },
  { name: "Finland", iso: "FI", dialCode: "+358" },
  { name: "France", iso: "FR", dialCode: "+33" },
  { name: "Gabon", iso: "GA", dialCode: "+241" },
  { name: "Gambia", iso: "GM", dialCode: "+220" },
  { name: "Georgia", iso: "GE", dialCode: "+995" },
  { name: "Germany", iso: "DE", dialCode: "+49" },
  { name: "Ghana", iso: "GH", dialCode: "+233" },
  { name: "Greece", iso: "GR", dialCode: "+30" },
  { name: "Grenada", iso: "GD", dialCode: "+1-473" },
  { name: "Guatemala", iso: "GT", dialCode: "+502" },
  { name: "Guinea", iso: "GN", dialCode: "+224" },
  { name: "Guinea-Bissau", iso: "GW", dialCode: "+245" },
  { name: "Guyana", iso: "GY", dialCode: "+592" },
  { name: "Haiti", iso: "HT", dialCode: "+509" },
  { name: "Honduras", iso: "HN", dialCode: "+504" },
  { name: "Hungary", iso: "HU", dialCode: "+36" },
  { name: "Iceland", iso: "IS", dialCode: "+354" },
  { name: "India", iso: "IN", dialCode: "+91" },
  { name: "Indonesia", iso: "ID", dialCode: "+62" },
  { name: "Iran", iso: "IR", dialCode: "+98" },
  { name: "Iraq", iso: "IQ", dialCode: "+964" },
  { name: "Ireland", iso: "IE", dialCode: "+353" },
  { name: "Israel", iso: "IL", dialCode: "+972" },
  { name: "Italy", iso: "IT", dialCode: "+39" },
  { name: "Ivory Coast", iso: "CI", dialCode: "+225" },
  { name: "Jamaica", iso: "JM", dialCode: "+1-876" },
  { name: "Japan", iso: "JP", dialCode: "+81" },
  { name: "Jordan", iso: "JO", dialCode: "+962" },
  { name: "Kazakhstan", iso: "KZ", dialCode: "+7" },
  { name: "Kenya", iso: "KE", dialCode: "+254" },
  { name: "Kiribati", iso: "KI", dialCode: "+686" },
  { name: "Kosovo", iso: "XK", dialCode: "+383" },
  { name: "Kuwait", iso: "KW", dialCode: "+965" },
  { name: "Kyrgyzstan", iso: "KG", dialCode: "+996" },
  { name: "Laos", iso: "LA", dialCode: "+856" },
  { name: "Latvia", iso: "LV", dialCode: "+371" },
  { name: "Lebanon", iso: "LB", dialCode: "+961" },
  { name: "Lesotho", iso: "LS", dialCode: "+266" },
  { name: "Liberia", iso: "LR", dialCode: "+231" },
  { name: "Libya", iso: "LY", dialCode: "+218" },
  { name: "Liechtenstein", iso: "LI", dialCode: "+423" },
  { name: "Lithuania", iso: "LT", dialCode: "+370" },
  { name: "Luxembourg", iso: "LU", dialCode: "+352" },
  { name: "Madagascar", iso: "MG", dialCode: "+261" },
  { name: "Malawi", iso: "MW", dialCode: "+265" },
  { name: "Malaysia", iso: "MY", dialCode: "+60" },
  { name: "Maldives", iso: "MV", dialCode: "+960" },
  { name: "Mali", iso: "ML", dialCode: "+223" },
  { name: "Malta", iso: "MT", dialCode: "+356" },
  { name: "Marshall Islands", iso: "MH", dialCode: "+692" },
  { name: "Mauritania", iso: "MR", dialCode: "+222" },
  { name: "Mauritius", iso: "MU", dialCode: "+230" },
  { name: "Mexico", iso: "MX", dialCode: "+52" },
  { name: "Micronesia", iso: "FM", dialCode: "+691" },
  { name: "Moldova", iso: "MD", dialCode: "+373" },
  { name: "Monaco", iso: "MC", dialCode: "+377" },
  { name: "Mongolia", iso: "MN", dialCode: "+976" },
  { name: "Montenegro", iso: "ME", dialCode: "+382" },
  { name: "Morocco", iso: "MA", dialCode: "+212" },
  { name: "Mozambique", iso: "MZ", dialCode: "+258" },
  { name: "Myanmar", iso: "MM", dialCode: "+95" },
  { name: "Namibia", iso: "NA", dialCode: "+264" },
  { name: "Nauru", iso: "NR", dialCode: "+674" },
  { name: "Nepal", iso: "NP", dialCode: "+977" },
  { name: "Netherlands", iso: "NL", dialCode: "+31" },
  { name: "New Zealand", iso: "NZ", dialCode: "+64" },
  { name: "Nicaragua", iso: "NI", dialCode: "+505" },
  { name: "Niger", iso: "NE", dialCode: "+227" },
  { name: "Nigeria", iso: "NG", dialCode: "+234" },
  { name: "North Korea", iso: "KP", dialCode: "+850" },
  { name: "North Macedonia", iso: "MK", dialCode: "+389" },
  { name: "Norway", iso: "NO", dialCode: "+47" },
  { name: "Oman", iso: "OM", dialCode: "+968" },
  { name: "Pakistan", iso: "PK", dialCode: "+92" },
  { name: "Palau", iso: "PW", dialCode: "+680" },
  { name: "Palestine", iso: "PS", dialCode: "+970" },
  { name: "Panama", iso: "PA", dialCode: "+507" },
  { name: "Papua New Guinea", iso: "PG", dialCode: "+675" },
  { name: "Paraguay", iso: "PY", dialCode: "+595" },
  { name: "Peru", iso: "PE", dialCode: "+51" },
  { name: "Philippines", iso: "PH", dialCode: "+63" },
  { name: "Poland", iso: "PL", dialCode: "+48" },
  { name: "Portugal", iso: "PT", dialCode: "+351" },
  { name: "Qatar", iso: "QA", dialCode: "+974" },
  { name: "Romania", iso: "RO", dialCode: "+40" },
  { name: "Russia", iso: "RU", dialCode: "+7" },
  { name: "Rwanda", iso: "RW", dialCode: "+250" },
  { name: "Saint Kitts and Nevis", iso: "KN", dialCode: "+1-869" },
  { name: "Saint Lucia", iso: "LC", dialCode: "+1-758" },
  { name: "Saint Vincent and the Grenadines", iso: "VC", dialCode: "+1-784" },
  { name: "Samoa", iso: "WS", dialCode: "+685" },
  { name: "San Marino", iso: "SM", dialCode: "+378" },
  { name: "Sao Tome and Principe", iso: "ST", dialCode: "+239" },
  { name: "Saudi Arabia", iso: "SA", dialCode: "+966" },
  { name: "Senegal", iso: "SN", dialCode: "+221" },
  { name: "Serbia", iso: "RS", dialCode: "+381" },
  { name: "Seychelles", iso: "SC", dialCode: "+248" },
  { name: "Sierra Leone", iso: "SL", dialCode: "+232" },
  { name: "Singapore", iso: "SG", dialCode: "+65" },
  { name: "Slovakia", iso: "SK", dialCode: "+421" },
  { name: "Slovenia", iso: "SI", dialCode: "+386" },
  { name: "Solomon Islands", iso: "SB", dialCode: "+677" },
  { name: "Somalia", iso: "SO", dialCode: "+252" },
  { name: "South Africa", iso: "ZA", dialCode: "+27" },
  { name: "South Korea", iso: "KR", dialCode: "+82" },
  { name: "South Sudan", iso: "SS", dialCode: "+211" },
  { name: "Spain", iso: "ES", dialCode: "+34" },
  { name: "Sri Lanka", iso: "LK", dialCode: "+94" },
  { name: "Sudan", iso: "SD", dialCode: "+249" },
  { name: "Suriname", iso: "SR", dialCode: "+597" },
  { name: "Sweden", iso: "SE", dialCode: "+46" },
  { name: "Switzerland", iso: "CH", dialCode: "+41" },
  { name: "Syria", iso: "SY", dialCode: "+963" },
  { name: "Taiwan", iso: "TW", dialCode: "+886" },
  { name: "Tajikistan", iso: "TJ", dialCode: "+992" },
  { name: "Tanzania", iso: "TZ", dialCode: "+255" },
  { name: "Thailand", iso: "TH", dialCode: "+66" },
  { name: "Timor-Leste", iso: "TL", dialCode: "+670" },
  { name: "Togo", iso: "TG", dialCode: "+228" },
  { name: "Tonga", iso: "TO", dialCode: "+676" },
  { name: "Trinidad and Tobago", iso: "TT", dialCode: "+1-868" },
  { name: "Tunisia", iso: "TN", dialCode: "+216" },
  { name: "Turkey", iso: "TR", dialCode: "+90" },
  { name: "Turkmenistan", iso: "TM", dialCode: "+993" },
  { name: "Tuvalu", iso: "TV", dialCode: "+688" },
  { name: "Uganda", iso: "UG", dialCode: "+256" },
  { name: "Ukraine", iso: "UA", dialCode: "+380" },
  { name: "United Arab Emirates", iso: "AE", dialCode: "+971" },
  { name: "United Kingdom", iso: "GB", dialCode: "+44" },
  { name: "United States", iso: "US", dialCode: "+1" },
  { name: "Uruguay", iso: "UY", dialCode: "+598" },
  { name: "Uzbekistan", iso: "UZ", dialCode: "+998" },
  { name: "Vanuatu", iso: "VU", dialCode: "+678" },
  { name: "Vatican City", iso: "VA", dialCode: "+379" },
  { name: "Venezuela", iso: "VE", dialCode: "+58" },
  { name: "Vietnam", iso: "VN", dialCode: "+84" },
  { name: "Yemen", iso: "YE", dialCode: "+967" },
  { name: "Zambia", iso: "ZM", dialCode: "+260" },
  { name: "Zimbabwe", iso: "ZW", dialCode: "+263" },
];

const SignUp = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    phoneCode: "+1",
    phoneCountryIso: "US",
    country: "",
    agreeToTerms: false,
    agreeToMarketing: false,
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [toast, setToast] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPhoneCodeDropdownOpen, setIsPhoneCodeDropdownOpen] = useState(false);
  const phoneCodeDropdownRef = useRef(null);

  const { register, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isDark = true;
  const signupInputClassName =
    "signup-input !min-h-[52px] !rounded-2xl !border-slate-200/80 !bg-white/95 !text-slate-950 !placeholder-slate-500 caret-slate-950 shadow-[0_18px_40px_-28px_rgba(15,23,42,0.85)] transition-all duration-300 hover:!border-slate-300 focus:!border-cyan-500 focus:!ring-cyan-500/30 focus:shadow-[0_22px_45px_-28px_rgba(6,182,212,0.45)]";
  const signupSelectClassName =
    "signup-select w-full min-h-[52px] rounded-2xl border border-slate-200/80 bg-white/95 px-4 py-3 text-slate-950 shadow-[0_18px_40px_-28px_rgba(15,23,42,0.85)] transition-all duration-300 placeholder:text-slate-500 hover:border-slate-300 focus:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/30 focus:shadow-[0_22px_45px_-28px_rgba(6,182,212,0.45)]";
  const sortedCountryDirectory = useMemo(
    () => [...countryDirectory].sort((a, b) => a.name.localeCompare(b.name)),
    []
  );
  const countries = sortedCountryDirectory.map(({ name }) => name);
  const phoneCountryOptions = sortedCountryDirectory.map((country) => ({
    ...country,
    label: `${country.iso} ${country.dialCode}`,
    flagSrc: `https://flagcdn.com/w40/${country.iso.toLowerCase()}.png`,
  }));
  const selectedPhoneCountry =
    phoneCountryOptions.find(
      (country) => country.iso === formData.phoneCountryIso
    ) || phoneCountryOptions[0];

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (formData.password) {
      const strength = calculatePasswordStrength(formData.password);
      setPasswordStrength(strength);
    }
  }, [formData.password]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        phoneCodeDropdownRef.current &&
        !phoneCodeDropdownRef.current.contains(event.target)
      ) {
        setIsPhoneCodeDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const calculatePasswordStrength = (password) => {
    let score = 0;
    if (password.length >= 8) score += 25;
    if (password.match(/[a-z]/)) score += 25;
    if (password.match(/[A-Z]/)) score += 25;
    if (password.match(/[0-9]/)) score += 25;
    if (password.match(/[^a-zA-Z0-9]/)) score += 25;
    return Math.min(score, 100);
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength < 25) return "bg-red-500";
    if (passwordStrength < 50) return "bg-orange-500";
    if (passwordStrength < 75) return "bg-yellow-500";
    return "bg-green-500";
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength < 25) return "Weak";
    if (passwordStrength < 50) return "Fair";
    if (passwordStrength < 75) return "Good";
    return "Strong";
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone") {
      const sanitizedPhone = value.replace(/\D/g, "");
      setFormData((prev) => ({
        ...prev,
        phone: sanitizedPhone,
      }));
    } else if (name === "country") {
      const matchedCountry = countryDirectory.find(
        (country) => country.name === value
      );
      setFormData((prev) => ({
        ...prev,
        country: value,
        phoneCode: matchedCountry?.dialCode || prev.phoneCode,
        phoneCountryIso: matchedCountry?.iso || prev.phoneCountryIso,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handlePhoneCodeChange = (selectedIso) => {
    const matchedCountry = countryDirectory.find(
      (country) => country.iso === selectedIso
    );

    if (!matchedCountry) return;

    setFormData((prev) => ({
      ...prev,
      phoneCode: matchedCountry.dialCode,
      phoneCountryIso: matchedCountry.iso,
      country: prev.country || matchedCountry.name,
    }));
    setIsPhoneCodeDropdownOpen(false);
  };

  const validateStep = (step) => {
    const newErrors = {};

    if (step === 1) {
      // Personal Information
      const firstNameError = validateName(formData.firstName, "First name");
      if (firstNameError) newErrors.firstName = firstNameError;

      const lastNameError = validateName(formData.lastName, "Last name");
      if (lastNameError) newErrors.lastName = lastNameError;

      const emailError = validateEmail(formData.email);
      if (emailError) newErrors.email = emailError;

      if (!formData.country) {
        newErrors.country = "Please select your country";
      }
    }

    if (step === 2) {
      // Security
      const passwordError = validatePassword(formData.password);
      if (passwordError) newErrors.password = passwordError;

      if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }

      if (!formData.agreeToTerms) {
        newErrors.agreeToTerms = "You must agree to the terms and conditions";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(2);
    }
  };

  const handleBack = () => {
    setCurrentStep(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep(2)) {
      return;
    }

    setIsSubmitting(true);
    setErrors({}); // Clear any previous errors

    try {
      const registrationPayload = {
        ...formData,
        phone: formData.phone
          ? `${formData.phoneCode}${formData.phone}`
          : "",
      };

      delete registrationPayload.phoneCode;
      delete registrationPayload.phoneCountryIso;

      const result = await register(registrationPayload);

      if (result.success) {
        setToast({
          type: "success",
          message:
            result.data.message ||
            "Account created successfully! Redirecting to your dashboard.",
        });

        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      } else {
        // Handle specific error cases
        const errorMessage =
          result.error || "Registration failed. Please try again.";

        // Check for specific error types and set field errors
        if (
          errorMessage.toLowerCase().includes("email") &&
          errorMessage.toLowerCase().includes("exists")
        ) {
          setErrors({ email: "An account with this email already exists" });
          setCurrentStep(1); // Go back to step 1 to fix email
        } else if (errorMessage.toLowerCase().includes("email")) {
          setErrors({ email: errorMessage });
          setCurrentStep(1);
        } else if (errorMessage.toLowerCase().includes("password")) {
          setErrors({ password: errorMessage });
        } else if (
          errorMessage.toLowerCase().includes("first name") ||
          errorMessage.toLowerCase().includes("firstname")
        ) {
          setErrors({ firstName: errorMessage });
          setCurrentStep(1);
        } else if (
          errorMessage.toLowerCase().includes("last name") ||
          errorMessage.toLowerCase().includes("lastname")
        ) {
          setErrors({ lastName: errorMessage });
          setCurrentStep(1);
        } else if (errorMessage.toLowerCase().includes("country")) {
          setErrors({ country: errorMessage });
          setCurrentStep(1);
        } else {
          setToast({
            type: "error",
            message: errorMessage,
          });
        }
      }
    } catch (error) {
      // Handle network errors
      if (!navigator.onLine) {
        setToast({
          type: "error",
          message:
            "No internet connection. Please check your network and try again.",
        });
      } else if (
        error.name === "TypeError" &&
        error.message.includes("fetch")
      ) {
        setToast({
          type: "error",
          message: "Unable to connect to server. Please try again later.",
        });
      } else {
        setToast({
          type: "error",
          message: "An unexpected error occurred. Please try again.",
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSocialSignUp = async (provider) => {
    try {
      // Implement social signup logic here
      setToast({
        type: "info",
        message: `${provider} signup coming soon!`,
      });
    } catch (error) {
      setToast({
        type: "error",
        message: `${provider} signup failed`,
      });
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[radial-gradient(circle_at_top_left,_rgba(8,145,178,0.22),_transparent_24%),linear-gradient(135deg,#020617,#0f172a_54%,#082f49)] p-4"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="rounded-[30px] bg-[linear-gradient(145deg,rgba(34,211,238,0.24),rgba(99,102,241,0.18),rgba(15,23,42,0.9))] p-[1px] shadow-[0_28px_80px_-34px_rgba(8,145,178,0.5)]">
          <div className="overflow-hidden rounded-[29px] border border-white/8 bg-[radial-gradient(circle_at_top,_rgba(34,211,238,0.12),_transparent_34%),linear-gradient(160deg,rgba(2,6,23,0.96),rgba(15,23,42,0.94)_52%,rgba(8,47,73,0.9))] text-slate-100 backdrop-blur-xl">
          <div className="p-6 sm:p-8">
            {/* Header */}
            <div className="text-center mb-7 sm:mb-8">
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5 }}
                className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-purple-600 shadow-[0_20px_50px_-20px_rgba(59,130,246,0.85)]"
              >
                <span className="text-2xl font-bold text-white">G</span>
              </motion.div>
              <h1 className="mb-2 text-2xl font-bold text-white">Create Account</h1>
              <p className="text-slate-300">Join thousands of successful traders</p>
            </div>

            {/* Progress Indicator */}
            <div className="flex items-center justify-center mb-8">
              <div className="flex items-center space-x-4">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                    currentStep >= 1
                      ? "bg-blue-500 text-white"
                      : isDark
                      ? "bg-slate-600 text-slate-400"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  1
                </div>
                <div
                  className={`h-0.5 w-8 ${
                    currentStep >= 2
                      ? "bg-blue-500"
                      : isDark
                      ? "bg-slate-600"
                      : "bg-gray-300"
                  }`}
                />
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                    currentStep >= 2
                      ? "bg-blue-500 text-white"
                      : isDark
                      ? "bg-slate-600 text-slate-400"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  2
                </div>
              </div>
            </div>

            {/* Step 1: Personal Information */}
            {currentStep === 1 && (
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
              >
                {/* Social Sign Up Buttons */}
                <div className="mb-6 space-y-3">
                  <Button
                    variant="outline"
                    className={`w-full min-h-[52px] rounded-2xl border transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_20px_45px_-28px_rgba(15,23,42,0.85)] ${
                      isDark
                        ? "border-slate-700 bg-slate-900/80 text-white hover:bg-slate-800"
                        : "text-gray-700 border-gray-300 hover:bg-gray-50"
                    }`}
                    onClick={() => handleSocialSignUp("Google")}
                  >
                    <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                      />
                      <path
                        fill="currentColor"
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                      />
                      <path
                        fill="currentColor"
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                      />
                      <path
                        fill="currentColor"
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                      />
                    </svg>
                    Continue with Google
                  </Button>
                </div>

                {/* Divider */}
                <div className="relative mb-6">
                  <div className="absolute inset-0 flex items-center">
                    <div
                      className={`w-full border-t ${
                        isDark ? "border-slate-600" : "border-gray-300"
                      }`}
                    ></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span
                      className={`px-3 ${
                        isDark
                          ? "rounded-full border border-white/10 bg-slate-950/90 text-slate-400"
                          : "bg-white text-gray-500"
                      }`}
                    >
                      or
                    </span>
                  </div>
                </div>

                <div className="space-y-4 sm:space-y-5">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <Input
                      type="text"
                      name="firstName"
                      placeholder="First name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      error={errors.firstName}
                      className={signupInputClassName}
                    />
                    <Input
                      type="text"
                      name="lastName"
                      placeholder="Last name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      error={errors.lastName}
                      className={signupInputClassName}
                    />
                  </div>

                  <Input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleInputChange}
                    error={errors.email}
                    className={signupInputClassName}
                  />

                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,188px)_minmax(0,1fr)]">
                    <div className="relative" ref={phoneCodeDropdownRef}>
                      <button
                        type="button"
                        onClick={() =>
                          setIsPhoneCodeDropdownOpen((open) => !open)
                        }
                        className={`${signupSelectClassName} flex items-center justify-between gap-3 text-left text-sm sm:text-base`}
                        aria-haspopup="listbox"
                        aria-expanded={isPhoneCodeDropdownOpen}
                      >
                        <span className="flex min-w-0 items-center gap-3">
                          <img
                            src={selectedPhoneCountry.flagSrc}
                            alt={`${selectedPhoneCountry.name} flag`}
                            className="h-4 w-6 rounded-sm object-cover shadow-sm"
                            loading="lazy"
                          />
                          <span className="truncate font-medium text-slate-900">
                            {selectedPhoneCountry.label}
                          </span>
                        </span>
                        <svg
                          className={`h-4 w-4 shrink-0 text-slate-500 transition-transform duration-200 ${
                            isPhoneCodeDropdownOpen ? "rotate-180" : ""
                          }`}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>

                      {isPhoneCodeDropdownOpen && (
                        <div className="absolute left-0 right-0 top-[calc(100%+0.5rem)] z-30 overflow-hidden rounded-2xl border border-slate-700/70 bg-slate-950/98 shadow-[0_30px_80px_-30px_rgba(2,6,23,0.95)] backdrop-blur-xl">
                          <div
                            className="max-h-72 overflow-y-auto py-2"
                            role="listbox"
                            aria-label="Phone country code"
                          >
                            {phoneCountryOptions.map((country) => (
                              <button
                                key={`${country.iso}-${country.dialCode}`}
                                type="button"
                                onClick={() =>
                                  handlePhoneCodeChange(country.iso)
                                }
                                className={`flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors duration-200 hover:bg-slate-800/85 ${
                                  country.iso === formData.phoneCountryIso
                                    ? "bg-slate-800/70"
                                    : ""
                                }`}
                                role="option"
                                aria-selected={
                                  country.iso === formData.phoneCountryIso
                                }
                              >
                                <img
                                  src={country.flagSrc}
                                  alt={`${country.name} flag`}
                                  className="h-4 w-6 rounded-sm object-cover shadow-sm"
                                  loading="lazy"
                                />
                                <span className="min-w-0 flex-1 truncate text-sm font-medium text-slate-100">
                                  {country.label}
                                </span>
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <Input
                      type="tel"
                      name="phone"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      placeholder="Phone number"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className={signupInputClassName}
                    />
                  </div>

                  <div>
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                      className={`${signupSelectClassName} ${
                        errors.country
                          ? "border-red-500"
                          : "border-slate-200/80"
                      }`}
                    >
                      <option value="">Select your country</option>
                      {countries.map((country) => (
                        <option
                          key={country}
                          value={country}
                          className="bg-white text-slate-950"
                        >
                          {country}
                        </option>
                      ))}
                    </select>
                    {errors.country && (
                      <p className="mt-1 text-sm text-red-400">
                        {errors.country}
                      </p>
                    )}
                  </div>
                </div>

                <Button
                  onClick={handleNext}
                  className="mt-6 min-h-[54px] w-full rounded-2xl bg-gradient-to-r from-blue-500 to-purple-600 shadow-[0_22px_55px_-28px_rgba(79,70,229,0.95)] transition-all duration-300 hover:-translate-y-0.5 hover:from-blue-600 hover:to-purple-700 hover:shadow-[0_26px_60px_-26px_rgba(79,70,229,1)] disabled:cursor-not-allowed disabled:opacity-50"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <div className="flex items-center justify-center space-x-2">
                      <LoadingSpinner size="sm" />
                      <span>Processing...</span>
                    </div>
                  ) : (
                    "Continue"
                  )}
                </Button>
              </motion.div>
            )}

            {/* Step 2: Security */}
            {currentStep === 2 && (
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
              >
                <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                  <div>
                    <div className="relative">
                      <Input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Create password"
                        value={formData.password}
                        onChange={handleInputChange}
                        error={errors.password}
                        className={`${signupInputClassName} pr-11`}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 transition-colors hover:text-slate-900"
                      >
                        {showPassword ? "🙈" : "👁️"}
                      </button>
                    </div>

                    {/* Password Strength Indicator */}
                    {formData.password && (
                      <div className="mt-2">
                        <div className="flex items-center space-x-2">
                          <div
                            className={`flex-1 rounded-full h-2 ${
                              isDark ? "bg-slate-600" : "bg-gray-300"
                            }`}
                          >
                            <div
                              className={`h-2 rounded-full transition-all duration-300 ${getPasswordStrengthColor()}`}
                              style={{ width: `${passwordStrength}%` }}
                            />
                          </div>
                          <span
                            className={`text-xs ${
                              isDark ? "text-slate-400" : "text-gray-500"
                            }`}
                          >
                            {getPasswordStrengthText()}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="relative">
                    <Input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Confirm password"
                      value={formData.confirmPassword}
                      onChange={handleInputChange}
                      error={errors.confirmPassword}
                      className={`${signupInputClassName} pr-11`}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 transition-colors hover:text-slate-900"
                    >
                      {showConfirmPassword ? "🙈" : "👁️"}
                    </button>
                  </div>

                  <div className="space-y-3">
                    <label className="flex items-start space-x-3">
                      <input
                        type="checkbox"
                        name="agreeToTerms"
                        checked={formData.agreeToTerms}
                        onChange={handleInputChange}
                        className={`mt-1 rounded text-blue-500 focus:ring-blue-500 focus:ring-offset-0 ${
                          isDark
                            ? "border-slate-600 bg-slate-700"
                            : "border-gray-300 bg-white"
                        }`}
                      />
                      <span
                        className={`text-sm ${
                          isDark ? "text-slate-300" : "text-gray-700"
                        }`}
                      >
                        I agree to the{" "}
                        <Link
                          to="/terms"
                          className={
                            isDark
                              ? "text-blue-400 hover:text-blue-300"
                              : "text-blue-600 hover:text-blue-500"
                          }
                        >
                          Terms of Service
                        </Link>{" "}
                        and{" "}
                        <Link
                          to="/privacy"
                          className={
                            isDark
                              ? "text-blue-400 hover:text-blue-300"
                              : "text-blue-600 hover:text-blue-500"
                          }
                        >
                          Privacy Policy
                        </Link>
                      </span>
                    </label>
                    {errors.agreeToTerms && (
                      <p className="text-sm text-red-400">
                        {errors.agreeToTerms}
                      </p>
                    )}

                    <label className="flex items-start space-x-3">
                      <input
                        type="checkbox"
                        name="agreeToMarketing"
                        checked={formData.agreeToMarketing}
                        onChange={handleInputChange}
                        className={`mt-1 rounded text-blue-500 focus:ring-blue-500 focus:ring-offset-0 ${
                          isDark
                            ? "border-slate-600 bg-slate-700"
                            : "border-gray-300 bg-white"
                        }`}
                      />
                      <span
                        className={`text-sm ${
                          isDark ? "text-slate-300" : "text-gray-700"
                        }`}
                      >
                        I want to receive trading insights and market updates
                      </span>
                    </label>
                  </div>

                  <div className="flex space-x-3">
                    <Button
                      type="button"
                      variant="outline"
                      onClick={handleBack}
                    className={`min-h-[52px] flex-1 rounded-2xl transition-all duration-300 hover:-translate-y-0.5 ${
                      isDark
                        ? "border-slate-700 bg-slate-900/70 text-white hover:bg-slate-800"
                        : "text-gray-700 border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      Back
                    </Button>
                    <Button
                      type="submit"
                      className="min-h-[52px] flex-1 rounded-2xl bg-gradient-to-r from-blue-500 to-purple-600 shadow-[0_22px_55px_-28px_rgba(79,70,229,0.95)] transition-all duration-300 hover:-translate-y-0.5 hover:from-blue-600 hover:to-purple-700 hover:shadow-[0_26px_60px_-26px_rgba(79,70,229,1)] disabled:cursor-not-allowed disabled:opacity-50"
                      disabled={loading || isSubmitting}
                    >
                      {loading || isSubmitting ? (
                        <div className="flex items-center justify-center space-x-2">
                          <LoadingSpinner size="sm" />
                          <span>Creating Account...</span>
                        </div>
                      ) : (
                        "Create Account"
                      )}
                    </Button>
                  </div>
                </form>
              </motion.div>
            )}

            {/* Sign In Link */}
            <div className="mt-6 text-center">
              <p className={isDark ? "text-slate-400" : "text-gray-600"}>
                Already have an account?{" "}
                <Link
                  to="/login"
                  className={`font-medium transition-colors ${
                    isDark
                      ? "text-blue-400 hover:text-blue-300"
                      : "text-blue-600 hover:text-blue-500"
                  }`}
                >
                  Sign in
                </Link>
              </p>
            </div>
          </div>
          </div>
        </div>
      </motion.div>

      {/* Toast Notifications */}
      {toast && (
        <Toast
          type={toast.type}
          message={toast.message}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default SignUp;
